export default __webpack_public_path__ + "static/simplea-3ba4a2ea2ee37e5633002828d3536c37.png";